import { Box, Tooltip } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'
import SimpleCircularProgressWithLabel from '../../../components/progress/SimpleCircularProgressWithLabel'
import { PASTEL_COLOR } from '../../../utils/constants/ColorTheme'

const SIZE = 40
const TRACK_OPACITY = 0.25

const getColor = (done, total) => {
    if (!done) return PASTEL_COLOR.red
    if (done >= total) return PASTEL_COLOR.green
    return PASTEL_COLOR.orange
}

const CampaignProgress = ({
    done = 0,
    total = 0,
}) => {
    const color = getColor(done, total)

    return (
        <Tooltip title={`${done}/${total}`}>
            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                <SimpleCircularProgressWithLabel
                    value={total ? (done / total) * 100 : 0}
                    size={SIZE}
                    enableTrackSlot
                    sx={{
                        color,
                        backgroundColor: 'transparent',
                        '& svg': {
                            backgroundColor: 'transparent',
                        },
                        '& .MuiCircularProgress-track': {
                            backgroundColor: color,
                            opacity: TRACK_OPACITY,
                        },
                    }}
                    data-cy='campaignProgress'
                />
            </Box>
        </Tooltip>
    )
}

CampaignProgress.propTypes = {
    done: PropTypes.number,
    total: PropTypes.number,
}

export default CampaignProgress
